import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppsManagement } from '../models/iDelibe/i-apps-management';
import { BasicPointInfos, Point } from '../models/iDelibe/point';
import { environment } from 'src/environments/environment';
import { MeRightsPointsSeancesDTO } from '../models';

@Injectable({
  providedIn: 'root',
})
export class IDelibeService {
  public apiBaseUrl: string;
  public headers: HttpHeaders;
  public body: FormData;
  public params: HttpParams = new HttpParams();

  constructor(public http: HttpClient) {
    const config = environment;
    this.apiBaseUrl = config.iDelibeApi + '/api/v1';
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    });
    this.body = new FormData();
    this.params = new HttpParams();
  }

  getiDelibeRights(): Observable<MeRightsPointsSeancesDTO> {
    return this.http.get<MeRightsPointsSeancesDTO>(`${this.apiBaseUrl}/Connecteurs/iCourrier/Me/Rights/PointsSeances`);
  }
  getUserAccessToiDelibe(): Observable<{
    userId: number;
    exist: boolean;
    canLogin: boolean;
  }> {
    return this.http.get<{
      userId: number;
      exist: boolean;
      canLogin: boolean;
    }>(`${this.apiBaseUrl}/Connecteurs/Externes/CheckUser`);
  }
  getIappsManagement(): Observable<IAppsManagement> {
    return this.http.get<IAppsManagement>(`${this.apiBaseUrl}/Connecteurs/iCourrier/Me/Rights/Counts`);
  }

  postLinkCourrierIdDelibeId(courrierIds: number[], delibeId: number): Observable<Point> {
    const request_body = {
      iCourrierIdsToLink: courrierIds,
    };
    return this.http.post<Point>(`${this.apiBaseUrl}/Connecteurs/iCourrier/Points/${delibeId}/Links`, request_body, {
      headers: this.headers,
    });
  }

  deleteIDelibeLinks(courrierId: number, pointId: number): Observable<void> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        iCourrierIdsToDeleteLink: [courrierId],
      },
    };
    return this.http.delete<void>(`${this.apiBaseUrl}/Connecteurs/iCourrier/Points/${pointId}/Links`, options);
  }

  getPointsInfos(listOfPointIds: number[]): Observable<BasicPointInfos[]> {
    return this.http.get<BasicPointInfos[]>(`${this.apiBaseUrl}/Connecteurs/iCourrier/Points/SearchBasic?pointIds=${listOfPointIds}`);
  }

  getPointFullInfos(pointId: number): Observable<Point> {
    return this.http.get<Point>(`${this.apiBaseUrl}/Connecteurs/iCourrier/Points/${pointId}`);
  }
}
